const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

let refreshRequest = null;

function getToken() {
  return localStorage.getItem('mol_id_token');
}

function clearStoredTokens() {
  localStorage.removeItem('mol_access_token');
  localStorage.removeItem('mol_id_token');
  localStorage.removeItem('mol_refresh_token');
}

function storeTokens(tokens) {
  if (tokens.access_token) {
    localStorage.setItem('mol_access_token', tokens.access_token);
  }
  if (tokens.id_token) {
    localStorage.setItem('mol_id_token', tokens.id_token);
  }
  if (tokens.refresh_token) {
    localStorage.setItem('mol_refresh_token', tokens.refresh_token);
  }
}

async function parseResponse(res) {
  const text = await res.text();
  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch (error) {
    const message = text.trim().startsWith('<')
      ? `Unexpected HTML response from server (${res.status})`
      : `Unexpected server response (${res.status})`;
    throw new Error(message);
  }
}

async function refreshTokens() {
  const refreshToken = localStorage.getItem('mol_refresh_token');
  if (!refreshToken) {
    return false;
  }

  if (!refreshRequest) {
    refreshRequest = (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/auth/refresh`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: refreshToken }),
        });
        const data = await parseResponse(res);

        if (!res.ok || !data?.success) {
          return false;
        }

        storeTokens(data.data || {});
        return Boolean(data.data?.id_token || data.data?.access_token);
      } catch (error) {
        return false;
      } finally {
        refreshRequest = null;
      }
    })();
  }

  return refreshRequest;
}

async function apiRequest(path, options = {}, allowRefresh = true) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
  };

  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    if (allowRefresh) {
      const refreshed = await refreshTokens();
      if (refreshed) {
        return apiRequest(path, options, false);
      }
    }

    clearStoredTokens();
    window.location.href = '/login';
    throw new Error('Unauthorized');
  }

  const data = await parseResponse(res);

  if (!res.ok) {
    throw new Error(data?.error || `Request failed (${res.status})`);
  }

  return data;
}

export function get(path) {
  return apiRequest(path, { method: 'GET' });
}

export function post(path, body) {
  return apiRequest(path, { method: 'POST', body: JSON.stringify(body) });
}

export function patch(path, body) {
  return apiRequest(path, { method: 'PATCH', body: JSON.stringify(body) });
}

export function del(path, body) {
  const opts = { method: 'DELETE' };
  if (body) opts.body = JSON.stringify(body);
  return apiRequest(path, opts);
}

export default { get, post, patch, del };
